import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import TablePagination from '@mui/material/TablePagination';
import { findByTdpCodigoAndCurrentUser } from '../api-presenca-aluno';
import CssBaseline from '@mui/material/CssBaseline';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector } from 'react-redux';
import { dateFormat } from '../../../util/DateUtil';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles({
    paper: {
        marginTop: '60px',
        backgroundColor: '#fff'
    },
    table: {
        minWidth: 650,
    },
    title: {
        paddingTop: '20px;',
        margin: '20px'
    },
    novoRegistro: {
        marginTop: '30px',
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    submit: {
        marginRight: '8px',
    },
    loading: {
        paddingTop: '50px',
        paddingBottom: '50px',
        paddingRight: '20px',
        paddingLeft: '20px'
    },
    rowHeader: {
        backgroundColor: '#b284d2',
        color: 'white',
        fontSize: 'large',
        fontWeight: '700'
    }
});


export default function PresencaTable() {
    const classes = useStyles();
    const [listaPA, setListaPA] = useState({
        content: [],
        totalElements: 0,
        number: 0,
        numberOfElements: 0
    });
    const tdp = useSelector(state => state.tdp);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        findByTdpCodigoAndCurrentUser(tdp.codigo, 0).then((data) => {
            if (data) {
                setListaPA(data);
                setLoading(false);
            }
        })
    }, [tdp.codigo]);

    const handleChangePage = (event, newPage) => {
        setLoading(true);
        findByTdpCodigoAndCurrentUser(tdp.codigo, newPage).then((data) => {
            if (data) {
                setListaPA(data);
            }
            setLoading(false);
        });
    };

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper}>


                {loading ?
                    <div className={classes.loading}>
                        <CircularProgress color="primary" />
                        Carregando...
                    </div>
                    :
                    <div style={{ paddingTop: '32px' }}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.rowHeader} style={{ width: "350px" }}>Conteúdo</TableCell>
                                    <TableCell className={classes.rowHeader}>Data</TableCell>
                                    <TableCell className={classes.rowHeader}>Situação</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {listaPA.content.map((pa) => (
                                    <TableRow key={pa.codigo}>
                                        <TableCell>{pa.presenca && pa.presenca.conteudo ? pa.presenca.conteudo : ''}</TableCell>
                                        <TableCell>{pa.presenca && pa.presenca.data ? dateFormat(pa.presenca.data) : ''}</TableCell>
                                        <TableCell>
                                            {pa.legendaDiario.descricao}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[]}
                            rowsPerPage={listaPA.size ? listaPA.size : 0}
                            component="div"
                            count={listaPA.totalElements}
                            page={listaPA.number}
                            onPageChange={handleChangePage}
                            labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                }



            </Container>
        </div>
    );
}